<template>
  <div>
    <Head :title="grate.part_number" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-blue-400 hover:text-blue-600" href="/grates">Grates</Link>
      <span class="text-blue-400 font-medium">/</span>
      {{ grate.part_number }}
    </h1>
    <p class="mb-10">
      {{ grate.description }}
    </p>
    <div class="flex mb-10">
      <div class="flex-auto w-2/4">
        <span class="font-bold mr-2">Filter by:</span>
        <select id="select-system-input" v-model="form.system" name="select-system-input" class="border px-2 h-12 mr-2">
          <option disabled value="null">--System</option>
          <option v-for="s in systems" :key="s.id" :value="s.id"> {{ s.name }}</option>
        </select>
        <select id="select-edge-input" v-model="form.edge" name="select-edge-input" class="border px-2 h-12 mr-2">
          <option disabled value="null">--Edge</option>
          <option v-for="e in edges" :key="e.id" :value="e.id"> {{ e.name }}</option>
        </select>
        <button v-if="form.system || form.edge" class="px-2 h-12 border text-gray-400" @click="form.reset('system'), form.reset('edge')">
          Clear
        </button>
      </div>
      <div class="w-2/4">
        <loading-button :loading="form.processing" class="btn-blue ml-auto" @click="update()">Configure Grate</loading-button>
      </div>
    </div>
    <form @submit.prevent="update">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6">
                # <input v-show="filteredChannels.length" type="checkbox" :checked="isSelected" @click="toggleAll" />
              </th>
              <th class="pb-4 pt-6 px-6">Nº</th>
              <th class="pb-4 pt-6 px-6">
                System
              </th>
              <th class="pb-4 pt-6 px-6">
                Edge
              </th>
              <th class="pb-4 pt-6 px-6">Part number</th>
              <th class="pb-4 pt-6 px-6">Length</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(c,i) in filteredChannels" :key="c.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-blue-200' : i % 2 == 0}">
              <td class="py-2 text-center"><input v-model="form.channels" type="checkbox" :value="c.id" /></td>
              <td class="py-2">{{ c.index }}</td>
              <td class="py-2">{{ c.system }}</td>
              <td class="py-2">{{ c.edge }}</td>
              <td class="py-2">{{ c.part_number }}</td>
              <td class="py-2">{{ c.length }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
    <loading-button :loading="form.processing" class="btn-blue ml-auto float-right mt-10" @click="update()">Configure Grate</loading-button>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
  },
  layout: Layout,
  props: {
    grate   : Object,
    systems : Array,
    channels: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        system: null,
        edge: null,
        channels: this.grate.channels,
      }),
    }
  },
  computed: {
    isSelected () {
      return this.form.channels.length > 0
    },
    filteredChannels () {
      let channels = this.channels
      if (this.form.system) {
        channels = channels.filter(c => c.system_id == this.form.system)
      }

      if (this.form.edge) {
        channels = channels.filter(c => c.edge_id == this.form.edge)
      }

      return channels
    },
    edges () {
      let edges = this.filteredChannels.map((ch) => {
        return { 'id': ch.edge_id, 'name' : ch.edge }
      })

      const result = []
      const map = new Map()
      for (const item of edges) {
        if(!map.has(item.id)){
          map.set(item.id, true)    // set any value to Map
          result.push({
            id: item.id,
            name: item.name,
          })
        }
      }

      return result
    },
  },
  methods: {
    update() {
      this.form.put(`/grates/${this.grate.id}/config`)
    },
    toggleAll (){
      if (! this.isSelected) {
        this.form.channels = this.filteredChannels.map(chnl => chnl.id)
      } else {
        this.form.channels = []
      }

    },
  },
}
</script>

<style>
  .bg-blue-200 {
    background-color: rgba(0, 43, 86, 0.05);
  }
</style>
